





















































import {
  defineComponent, PropType, ref, useContext, useFetch,
} from '@nuxtjs/composition-api';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import useNewsletter from "~/composables/useNewsletter";
import {NewsletterFormFields} from "../types";
import {SubscriptionStatusesEnum, useUiNotification} from "~/composables";
import { SfInput } from '@storefront-ui/vue';
import LoadWhenVisible from "~/components/utils/LoadWhenVisible.vue";
import {ContentConfigsInterface} from "~/modules/gomage/plugin-page-builder/types";

extend('email', {
  ...email,
  message: 'Please enter a valid email address (Ex: johndoe@domain.com).',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

export default defineComponent({
  name: 'NewsLetter',
  components: {
    LoadWhenVisible,
    SfInput,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    data: {
      type: Object as PropType<ContentConfigsInterface>,
    }
  },
  setup(props) {
    let dynamicStyles = null;
    let cssClasses = [];
    const data:ContentConfigsInterface = props.data;
    if(data) {
      dynamicStyles = {
        border: data.border,
        borderColor: data.borderColor,
        borderWidth: data.borderWidth,
        borderRadius: data.borderRadius,
        marginLeft: data.marginLeft,
        marginBottom: data.marginBottom,
        marginRight: data.marginRight,
        marginTop: data.marginTop,
        paddingBottom: data.paddingBottom,
        paddingLeft: data.paddingLeft,
        paddingRight: data.paddingRight,
        paddingTop: data.paddingTop,
        textAlign: data.textAlign
      };
      cssClasses = data.cssClasses;
    }

    const {
      send: sendNotification,
    } = useUiNotification();
    const { app: { i18n } } = useContext();
    const getInitialForm = () : NewsletterFormFields => ({
      email: '',
    });

    const form = ref(getInitialForm());

    const statusIsSubscribed = SubscriptionStatusesEnum.Subscribed;
    const statusIsSubscribedMessage = 'The confirmation request has been sent.';

    const {updateSubscription, error} = useNewsletter();

    const { fetch } = useFetch(async () => {
      const email = form.value.email;
      if(email === '') return;

      const result = await updateSubscription({ email });

      if(error?.value.updateSubscription?.message) {
        sendNotification({
          id: Symbol('update_subscription_not_updated'),
          message: i18n.t(error.value.updateSubscription.message) as string,
          type: 'danger',
          icon: 'error',
          persist: false,
          title: 'Subscription Not Updated',
        });
      } else if(result === statusIsSubscribed) {
        sendNotification({
          id: Symbol('update_subscription_updated'),
          message: i18n.t(statusIsSubscribedMessage) as string,
          persist: true,
          title: 'Subscription Updated',
          type: 'success',
          icon: 'check',
        });
      }
    })

    const submitForm = (resetValidationFn: () => void) => () => {
      fetch();
      form.value.email = '';
      resetValidationFn();
    };

    return {
      dynamicStyles,
      cssClasses,
      submitForm,
      form
    };
  },
});
